import { GeneratedType } from "@cosmjs/proto-signing";
import { MsgEthereumTx } from "./ts-client/tx";

export const ethermintTypes: ReadonlyArray<[string, GeneratedType]> = [
  ['/ethermint.evm.v1.MsgEthereumTx', MsgEthereumTx],
];


